import React from 'react';
import NewAnalyticsCharts from './NewAnalyticsCharts';

function AnalyticsSection({ teamAverages, sortedTeams, companyData, approvedEmployees, billingOverLimit }) {
  return (
    <NewAnalyticsCharts
      teamAverages={teamAverages}
      teams={sortedTeams}
      companyName={companyData?.name}
      companyData={companyData}
      approvedEmployees={approvedEmployees}
      billingOverLimit={billingOverLimit}
    />
  );
}

export default AnalyticsSection;